export default "__VITE_ASSET__ClZGM5pp__"